import '@babel/polyfill';
import Vue from 'vue';
import './plugins/vuetify';
import Toasted from 'vue-toasted';
import axios from 'axios';

import App from './App.vue';
import router from './router';
import store from './store';

import Config from '@/shared/constants/config';
import AuthService from './shared/helpers/auth';

Vue.config.productionTip = false;

const bootstrap = () => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app');

  const toastOptions = {
    position: 'bottom-right',
    duration: 6000,
    closeOnSwipe: true,
    iconPack: 'material'
  };
  Vue.use(Toasted, toastOptions);
};

axios.get(`config.json`).then(({ data }) => {
  Config.API.BASE_URL = data.api.baseUrl;
  Config.B2C.CLIENT_ID = data.b2c.clientId;
  Config.B2C.AUTHORITY = data.b2c.authority;
  Config.B2C.RESET_POLICY = data.b2c.resetPolicy;
  Config.B2C.B2C_SCOPES = data.b2c.b2cScopes;
  Config.B2C.POST_LOGOUT_REDIRECT_URI = data.b2c.postLogoutRedirectUri;
  Config.B2C.NAVIGATE_TO_LOGIN_REQUEST_URL = data.b2c.navigateToLoginRequestUrl;
  Config.B2C.VALIDATE_AUTHORITY = data.b2c.validateAuthority;

  Config.TIMESPANS.INDEMNITY_PROCESS.FROM = data.Timespans.IndemnityProcess.From;
  Config.TIMESPANS.INDEMNITY_PROCESS.UNTIL = data.Timespans.IndemnityProcess.Until;

  const authService = new AuthService();
  Vue.prototype.$AuthService = authService;

  if (window.location.hash === '' && window.location.search === '') {
    localStorage.setItem('employer', null);
  }

  if (window.location.search != null) {
    const s = window.location.search.split('=');
    if (s[0] === '?e') {
      localStorage.setItem('employer', s[1]);
    }
  }

  const user = authService.getUser();
  if (user) {
    authService
      .acquireToken()
      .then(() => {
        bootstrap();
      })
      .catch(err => {
        console.error(JSON.stringify(err, null, 2));
      });
  } else {
    authService.login();
  }
});
